import React from 'react'
import { connect } from 'react-redux'
import { IndexLink, Link } from 'react-router'
import PropTypes from 'prop-types'
import './PageLayout.scss'
import TopMenuBar from '../TopMenuBar/TopMenuBar'
import Dialog from 'material-ui/Dialog'
import CurtainWithProgress from '../../components/CurtainWithProgress'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'
// import { signoutApi } from '../../store/credential'
const Styles = {
  curtainStyle: {
    backgroundColor: 'rgba(0,0,0,0.2)',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

const mapDispatchToProps = {
  // signoutApi
  //  doLogout,
//  clearLogoutFailed,
//  getAccountInfo
}

const mapStateToProps = (state) => ({
  credential: state.credential
})

class PageLayout extends React.Component {
  _closeDialog () {
    this.props.clearLogoutFailed()
  }

  render () {
    const { credential } = this.props
    // var {register} = this.props;
    // console.log(this.props);
    // this.props.login && ({credentials, role, logoutStarted, logoutFailed} = this.props.login);
    if (this.props.login) { var { credentials, role, loginFailed, logoutStarted, logoutFailed } = this.props.login }

    return (
      <div>
        <TopMenuBar/>
        <div className='page-layout__viewport'>
          {this.props.children}
        </div>
        { logoutStarted && <CurtainWithProgress /> }
        { logoutFailed && <Dialog
          title={'Logout Failed'}
          modal
          open={logoutFailed}
          onRequestClose={this._closeDialog.bind(this)}
          actions={[
            <FlatButton label='OK' primary onTouchTap={this._closeDialog.bind(this)} />
          ]}
          >
          {'Please try again later or close browser completely.'}
        </Dialog>}
      </div>
    )
  }
}

PageLayout.propTypes = {
  children: PropTypes.node,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageLayout)



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js